import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-background text-text-primary flex flex-col selection:bg-verdict-primary/30">
      {/* Ambient Lighting - Gold spotlight */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-20%] left-1/2 -translate-x-1/2 w-[600px] h-[500px] bg-verdict-primary/8 blur-[120px] rounded-full" />
        <div className="absolute bottom-[-30%] right-[-10%] w-[400px] h-[400px] bg-verdict-primary/5 blur-[100px] rounded-full" />
      </div>

      {/* Main content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-4xl">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
